import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import Table from "../components/Table";
import filePDF from "../assets/images/file-pdf.svg";
import lifeinsuranceIcon from "../assets/images/life-insurance.svg";
import PdfDownloader from "../components/PdfDownloader";
import Skeleton from "@mui/material/Skeleton";
import ErrorComp from "../components/ErrorComp";
import * as am5 from "@amcharts/amcharts5";
import Chart from "../components/Chart";
const LoansPage = (props) => {
  const [data, setData] = useState(null);
  const [cardData1, setCardData1] = useState(null);
  const [loading, setLoading] = useState(true);
  const [horizontalChartsData, setHorizontalChartsData] = useState([]);
  const [cardDataFund, setcardDataFund] = useState([]);
  const getRandomGreenToBlueColor = (index = 1) => {
    const colors = [
      "#0072E0",
      "#158EA5",
      "#88D892",
      "#5DC8DE",
      "#AD8EE1",
      "#C58EE1",
      "#8EE1D6",
      "#A6E18E",
      "#D8E18E",
      "#DE5DDA",
    ];
    const color = colors[index];
    return am5.color(color);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        let allLoans = (props?.pensionPolicies || [])
          // .filter((item) => item?.duplicate !== true)
          .flatMap((item) => {
            let halvas = Array.isArray(item?.Halvaa)
              ? item?.Halvaa
              : [item?.Halvaa];
            return halvas?.map((h) => ({
              ...item,
              Halvaa: h,
            }));
          });
        let allLoansWithoutDuplicate = (props?.pensionPolicies || []).flatMap(
          (item) => {
            let halvas = Array.isArray(item?.Halvaa)
              ? item?.Halvaa
              : [item?.Halvaa];
            return halvas?.map((h) => ({
              ...item,
              Halvaa: h,
            }));
          },
        );
        // Deduplicate by MISDAR_SIDURI_SHEL_HAHALVAA
        const uniqueLoansMap = new Map();
        allLoans.forEach((loan) => {
          const key = loan?.Halvaa?.MISDAR_SIDURI_SHEL_HAHALVAA;
          if (key && !uniqueLoansMap.has(key)) {
            uniqueLoansMap.set(key, loan);
          }
        });
        console.log("uniqueLoansMap Without", uniqueLoansMap);
        const uniqueLoans = Array.from(uniqueLoansMap.values());

        // Deduplicate by MISDAR_SIDURI_SHEL_HAHALVAA
        const uniqueLoansMapWD = new Map();
        allLoansWithoutDuplicate.forEach((loan) => {
          const key = loan?.Halvaa?.MISDAR_SIDURI_SHEL_HAHALVAA;
          if (key && !uniqueLoansMapWD.has(key)) {
            uniqueLoansMapWD.set(key, loan);
          }
        });
        console.log("uniqueLoansMap Without", uniqueLoansMapWD);
        const uniqueLoansWD = Array.from(uniqueLoansMapWD.values());

        // Update state for table
        setData(uniqueLoansWD);
        console.log("Unique loans", uniqueLoans);

        let cardData = {
          YITRAT_KASPEY_TAGMULIM: 0,
          MOED_NEZILUT_TAGMULIM: 0,
        };

        const yitrat = props.pensionPolicies.reduce((acc, item) => {
          // if (item?.duplicate === true) return acc;
          if (
            item.PirteiTaktziv &&
            item.PirteiTaktziv.length > 0 &&
            item.PirteiTaktziv[0].NesilutTag &&
            item.PirteiTaktziv[0].NesilutTag.YITRAT_KASPEY_TAGMULIM
          ) {
            const value = parseFloat(
              item.PirteiTaktziv[0].NesilutTag.YITRAT_KASPEY_TAGMULIM || 0,
            );
            return acc + value;
          }
          return acc;
        }, 0);

        const moed = props.pensionPolicies.reduce((acc, item) => {
          // if (item?.duplicate === true) return acc;
          if (
            item.PirteiTaktziv &&
            item.PirteiTaktziv.length > 0 &&
            item.PirteiTaktziv[0].NesilutTag &&
            item.PirteiTaktziv[0].NesilutTag.YITRAT_KASPEY_TAGMULIM
          ) {
            const value = parseFloat(
              item.PirteiTaktziv[0].NesilutTag.YITRAT_KASPEY_TAGMULIM || 0,
            );
            return acc + value;
          }
          return acc;
        }, 0);

        cardData.YITRAT_KASPEY_TAGMULIM = yitrat.toLocaleString("he-IL", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        cardData.MOED_NEZILUT_TAGMULIM = moed.toLocaleString("he-IL", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        setCardData1(cardData);

        const transformedData = [
          {
            category: "סך יתרת ההלוואה",
            value: uniqueLoans.reduce((sum, item) => {
              const halvaa = Array.isArray(item.Halvaa)
                ? item.Halvaa[0]
                : item.Halvaa;
              return sum + parseFloat(halvaa?.YITRAT_HALVAA || 0);
            }, 0),
            settings: {
              fill: getRandomGreenToBlueColor(0),
            },
          },
          {
            category: "סך הלוואות ששולמו",
            value: Math.max(
              uniqueLoans.reduce((sum, item) => {
                const halvaa = Array.isArray(item.Halvaa)
                  ? item.Halvaa[0]
                  : item.Halvaa;
                return sum + parseFloat(halvaa?.SCHUM_HALVAA || 0);
              }, 0) -
                uniqueLoans.reduce((sum, item) => {
                  const halvaa = Array.isArray(item.Halvaa)
                    ? item.Halvaa[0]
                    : item.Halvaa;
                  return sum + parseFloat(halvaa?.YITRAT_HALVAA || 0);
                }, 0),
              0,
            ),
            settings: {
              fill: getRandomGreenToBlueColor(1),
            },
          },
        ];

        const cardArrayData = [
          {
            title: "ממוצע % ריבית",
            RIBIT: (() => {
              if (!props?.pensionPolicies?.length) return 0;

              let total = 0;
              let count = 0;

              for (const item of uniqueLoans || []) {
                const halvaa = Array.isArray(item?.Halvaa)
                  ? item?.Halvaa?.[0]
                  : item?.Halvaa || {};
                const ribit = parseFloat(halvaa?.RIBIT || 0);

                if (ribit > 0) {
                  total += ribit;
                  count++;
                }
              }

              return count ? total / count : 0;
            })(),
          },
          {
            title: "סה”כ החזרים תקופתיים",
            SCHUM_HECHZER_TKUFATI: uniqueLoans.reduce((sum, item) => {
              const halvaa = Array.isArray(item?.Halvaa)
                ? item?.Halvaa?.[0]
                : item?.Halvaa || {};
              return sum + parseFloat(halvaa?.SCHUM_HECHZER_TKUFATI || 0);
            }, 0),
          },
        ];
        setcardDataFund(cardArrayData);
        let arrayDataForChart = [
          {
            id: `filteredHEALTHArray-${props?.pensionPolicies?.length || 0}`,
            title: "Not fixed",
            total: transformedData
              .reduce((total, item) => total + (item?.value || 0), 0)
              .toFixed(0),
            totalLabel: "סך הכל מזומן",
            data: transformedData,
          },
        ];
        setHorizontalChartsData(arrayDataForChart);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [props?.pensionPolicies, props?.onboardingStep]);
  const [tableHeader, setTableHeader] = useState([
    { label: "חברה", sortable: true, engTrns: "policyRef" },
    { label: "מס פוליסה", sortable: true, engTrns: "policyNumber" },
    { label: "מספר סידורי של ההלוואה", sortable: false, engTrns: "loanOrder" },
    { label: "סכום ההלוואה", sortable: false, engTrns: "loanAmount" },
    { label: "יתרת סכום ההלוואה", sortable: false, engTrns: "remainingLoan" },
    { label: "ריבית", sortable: false, engTrns: "interestRate" },
    {
      label: "תאריך ערב ההלוואה",
      sortable: false,
      engTrns: "loanReceivedDate",
    },
    { label: "תאריך סיום ההלוואה", sortable: false, engTrns: "loanEndDate" },
    { label: "תדירות ההחזר", sortable: false, engTrns: "repaymentFrequency" },
    { label: "תקופת החזר של חודש", sortable: false, engTrns: "loanPeriod" },
    { label: "החזר תקופתי", sortable: false, engTrns: "periodicRepayment" },
    { label: "סוג ריבית", sortable: false, engTrns: "interestType" },
    { label: "הצמדה", sortable: false, engTrns: "indexationType" },
    { label: "סוג ההחזר", sortable: false, engTrns: "repaymentType" },
    { label: "תאריך נכונות", sortable: false, engTrns: "date" },
  ]);

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data || {});
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name || ""}
              </Link>
              <Typography>
                <b>הלוואות</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData?.full_name || ""}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="loanspage.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
          <p>
            ברוכים הבאים ללוח הבקרה הפיננסי שלכם! כאן תוכלו לגלות את כל המידע
            הדרוש לתכנון ולניהול של הפרישה שלכם!
            <br />
            עמוד זה מציע מבט מקיף על המצב הכלכלי שלכם, תוכלו להבין כמה כסף צברתם
            עד היום, כמה מתוכו נמצא בקרנות הפנסיה וקופות הגמל, חסכון וכו׳.
            <br />
            בנוסף תוכלו לקבל תמונה מקיפה על הקצבאות והצבירות בחשבונות שלכם,
            חסכונות והשקעות. תקבלו תובנות חשובות על נתוני הפנסיה, תזהו הזדמנויות
            לחיסכון נוסף ותוכלו לעקוב אחר ההתקדמות שלכם לעבר היעדים הפיננסיים.
            עם טיפים מותאמים אישית ותצוגה ברורה של הנתונים הכלכליים שלכם, תוכלו
            לקבל החלטות מושכלות ולשלוט בעתיד הפיננסי שלכם.
          </p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="loanspage.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props?.onboarding_error == 1 && <ErrorComp />}
      <div className="horizontalChart-section">
        <div className="title">
          <h2>הלוואות</h2>
        </div>
        <div className="row chart-row">
          {horizontalChartsData.length === 0 && loading
            ? [...Array(2)].map((_, index) => (
                <div className="col-6" key={`horizontal-${index}`}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={500}
                    animation="wave"
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      borderRadius: 1,
                      marginBottom: 2,
                    }}
                  />
                </div>
              ))
            : horizontalChartsData.map((chart, index) => (
                <div className="col-6" key={`horizontal-${index}`}>
                  <Chart
                    id={`hor${index}`}
                    data={chart.data}
                    total={chart.total}
                    title={chart.title}
                    totalLabel={chart.totalLabel}
                    variant="horizontal"
                    count="2"
                    from="loan"
                    cardArrayData={cardDataFund}
                    indexKey={index}
                  />
                </div>
              ))}
        </div>
      </div>
      <>
        <Table
          tableHeader={tableHeader}
          data={data}
          from="pensionPolicies"
          title=""
          loading={loading}
          notFoundMessage=""
        />
      </>

      <div className="loans-section">
        <div className="loans-cards d-flex flex-wrap gap-16">
          <div className="cards-box cardsIcon white-bg radius-16">
            <div className="content">
              <h6>
                המוצגות הם על סמך קרן פנסיה/ ביטוח מנהלים / קופת גמל / קרן
                השתלמות בלבד
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoansPage;
